// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__3Dosl","forms":"Login_forms__1MKIP"};